import { FieldsForProductInfo } from "../view-models/FieldsForProductInfo";
import {
  isOptProductFieldVisibility,
  isReqProductFieldVisibility,
} from "./sendValidationHelper";

export class GffpHelper {
  static filterRequiredAndOptionalFields(
    fieldsForProductInfo: FieldsForProductInfo,
  ) {
    return fieldsForProductInfo.productFieldInfos?.filter((field: any) => {
      const visibility = field?.visibility ?? field?.Visibility;
      return (
        isReqProductFieldVisibility(visibility) ||
        isOptProductFieldVisibility(visibility)
      );
    });
  }
}
